import { all, call, put, fork, takeEvery } from "redux-saga/effects";

import {
  HOLDED_GET_CONTACTS_LIST,
  HOLDED_GET_CONTACT_INFO,
  HOLDED_ADD_CONTACT_INFO,
  HOLDED_UPDATE_CONTACT_INFO,
  HOLDED_ADD_DOCUMENT_ITEM,
  HOLDED_CLEAR_DATA,
} from "../actions";

import {
  getContactsListHoldedSuccess,
  getContactsListHoldedError,
  getContactInfoHoldedSuccess,
  getContactInfoHoldedError,
  addContactInfoHoldedSuccess,
  addContactInfoHoldedError,
  updateContactInfoHoldedSuccess,
  updateContactInfoHoldedError,
  addDocumentItemHoldedSuccess,
  addDocumentItemHoldedError,
} from "./actions";

import moment from "moment";

const holdedKey = "b5048f42f504bc8b9751e2981bf646da";

//! 1. Our worker saga

//* GET CONTACTS LIST from Holded // ---------------------------------------------------------------------------------------------

const getContactsListHoldedRequest = async () => {
  return await fetch(`https://api.holded.com/api/invoicing/v1/contacts/`, {
    method: "get",
    headers: {
      accept: "application/json",
      key: "b5048f42f504bc8b9751e2981bf646da",

      // "Access-Control-Allow-Origin": "*",
      // "Access-Control-Allow-Credentials": "true",
      // "Access-Control-Allow-Methods": "GET,HEAD,OPTIONS,POST,PUT",
      // "Access-Control-Allow-Headers":
      //   "Origin, X-Requested-With, Content-Type, Accept, Authorization",
    },
  })
    .then((response) => response.json())
    .then((result) => {
      console.log(result);
      return result;
    });
};

function* getContactsListHolded() {
  // try {
  //   const response = yield call(getContactsListHoldedRequest);
  //   yield put(getContactsListHoldedSuccess(response));
  // } catch (error) {
  //   yield put(getContactsListHoldedError(error));
  // }
}

//* GET CONTACT INFO from Holded // ---------------------------------------------------------------------------------------------
const getContactInfoHoldedRequest = async (payload) => {
  console.log(payload.payload);

  let contactId = payload.payload;

  return await fetch(`/mick/holded/contacts/${contactId}`, {
    method: "get",

    headers: {
      accept: "application/json",
      key: "b5048f42f504bc8b9751e2981bf646da",

      // "Access-Control-Allow-Origin": "*",
      // "Access-Control-Allow-Credentials": "true",
      // "Access-Control-Allow-Methods": "GET,HEAD,OPTIONS,POST,PUT",
      // "Access-Control-Allow-Headers":
      //   "Origin, X-Requested-With, Content-Type, Accept, Authorization",
    },
  })
    .then((response) => response.json())
    .then((result) => {
      console.log(result);
      return result;
    });
};

function* getContactInfoHolded(payload) {
  try {
    const response = yield call(getContactInfoHoldedRequest, payload);

    yield put(getContactInfoHoldedSuccess(response));
  } catch (error) {
    yield put(getContactInfoHoldedError(error));
  }
}

//* CREATE CONTACT INFO to Holded // ---------------------------------------------------------------------------------------------
const addContactInfoHoldedRequest = async (payload) => {
  console.log(payload);

  const {
    //* CONTACT
    fullName,
    email,
    phone,
    language,

    //* SHIPPING ADDRESS
    recipientName,
    address,
    city,
    postalCode,
    province,
    country,
    details,

    //* BILLING ADDRESS
    fiscalAddress,
    fiscalCity,
    fiscalPostalCode,
    fiscalProvince,
    fiscalCountry,
    tradeName,
    isperson,
    fiscalId,
    isViesfiscalId,

    //* EXTRA
    contactType,
    affiliation,
    dashedAffiliation,
    doctorFullName,
    doctorEmail,
    doctorMobile,
    seqTechnology,
  } = payload.payload;

  console.log(isViesfiscalId);

  const stringedData = JSON.stringify({
    type: contactType,
    isperson: isperson,
    name: fullName,
    email: email,
    mobile: phone,
    code: isperson ? "" : fiscalId,
    tradeName: tradeName,
    language: language,

    billAddress: {
      address: fiscalAddress,
      city: fiscalCity,
      postalCode: fiscalPostalCode,
      province: fiscalProvince,
      country: fiscalCountry,
      isViesfiscalId: isViesfiscalId,
    },
    shippingAddresses: [
      {
        name: recipientName,
        address: address,
        city: city,
        postalCode: postalCode,
        country: country,
        province: province,
        notes: details,
      },
    ],
    contactPersons: [
      {
        name: doctorFullName,
        phone: doctorMobile,
        email: doctorEmail,
        affiliation: affiliation,
        dashedAffiliation: dashedAffiliation,
        seqTechnology: seqTechnology,
      },
    ],

    tags: [
      "mick-patient",
      dashedAffiliation,
      isViesfiscalId ? "VIES" : "",
      seqTechnology,
    ],
    note: `Affiliation: ${affiliation}; Referent doctor fullname:${doctorFullName}; Purpose of contact creation: patient requests KIT+analysis (MICK+ ${seqTechnology}) and proceeded with the payment with PayPal; Origin of the contact: Contact created by API from MICK frontend at page "KIT request"`,
  });

  console.log(stringedData);

  return await fetch(`/mick/holded/contacts?key=${holdedKey}`, {
    method: "POST",
    redirect: "follow",
    headers: {
      accept: "application/json",
      "content-type": "application/json",
      key: holdedKey,
    },

    body: stringedData,
  })
    .then((response) => response.json())
    .then((result) => {
      console.log(result);
      return result;
    });
};

function* addContactInfoHolded(payload) {
  try {
    const response = yield call(addContactInfoHoldedRequest, payload);
    console.log(typeof response, response);
    if (response.status === "success") {
      yield put(addContactInfoHoldedSuccess(response));
    } else {
      yield put(addContactInfoHoldedError(response.info));
    }
  } catch (error) {
    yield put(addContactInfoHoldedError(error));
  }
}

//? UPDATE CONTACT INFO to Holded  - NOT USED in frontend but managed by backend// ---------------------------------------------------------------------------------------------
const updateContactInfoHoldedRequest = async (payload) => {
  const {
    //* CONTACT
    fullName,
    email,
    phone,

    //* SHIPPING ADDRESS
    recipientName,
    address,
    city,
    postalCode,
    province,
    country,
    details,

    //* BILLING ADDRESS
    fiscalAddress,
    fiscalCity,
    fiscalPostalCode,
    fiscalProvince,
    fiscalCountry,
    tradeName,
    isperson,
    fiscalId,
    isViesfiscalId,

    //* EXTRA
    contactType,
    affiliation,
    dashedAffiliation,
    doctorFullName,
    doctorEmail,
    doctorMobile,
    seqTechnology,
  } = payload.payload;

  const stringedData = JSON.stringify({
    type: contactType,
    isperson: isperson,
    name: fullName,
    email: email,
    mobile: phone,
    code: isperson ? "" : fiscalId,
    tradeName: tradeName,

    billAddress: {
      address: fiscalAddress,
      city: fiscalCity,
      postalCode: fiscalPostalCode,
      province: fiscalProvince,
      country: fiscalCountry,
      isViesfiscalId: isViesfiscalId,
    },
    shippingAddresses: [
      {
        name: recipientName,
        address: address,
        city: city,
        postalCode: postalCode,
        country: country,
        province: province,
        notes: details,
      },
    ],
    contactPersons: [
      {
        name: doctorFullName,
        phone: doctorMobile,
        email: doctorEmail,
        affiliation: affiliation,
        dashedAffiliation: dashedAffiliation,
        seqTechnology: seqTechnology,
      },
    ],

    tags: [
      "mick-patient",
      dashedAffiliation,
      isViesfiscalId ? "VIES" : "",
      seqTechnology,
    ],
    note: `Affiliation: ${affiliation}; Referent doctor fullname:${doctorFullName}; Purpose of contact creation: patient requests KIT+analysis (MICK+ ${seqTechnology}) and proceeded with the payment with PayPal; Origin of the contact: Contact created by API from MICK frontend at page "KIT request"`,
  });

  console.log(stringedData);

  let contactId = payload.payload;

  return await fetch(`/mick/holded/contacts/${contactId}?key=${holdedKey}`, {
    method: "PUT",
    redirect: "follow",
    headers: {
      accept: "application/json",
      "content-type": "application/json",
      key: holdedKey,
    },

    body: stringedData,
  })
    .then((response) => response.json())
    .then((result) => {
      console.log(result);
      return result;
    });
};

function* updateContactInfoHolded(payload) {
  try {
    const response = yield call(updateContactInfoHoldedRequest, payload);
    console.log(typeof response, response);
    if (response.status === "success") {
      yield put(updateContactInfoHoldedSuccess(response));
    } else {
      yield put(updateContactInfoHoldedError(response.info));
    }
  } catch (error) {
    yield put(updateContactInfoHoldedError(error));
  }
}

//* CREATE SALE ORDER to Holded // ---------------------------------------------------------------------------------------------
const addDocumentItemHoldedRequest = async (payload) => {
  console.log(payload);

  var {
    customerHoldedId,
    docType,
    units,
    sku,
    isCompany,
    amount,
    seqTechnology,
    warehouseLocation,
    dashedAffiliation,
    isViesfiscalId,
    doctorFullName,
    doctorEmail,
    doctorMobile,
  } = payload.payload;

  //convert date to epoch
  var today = moment().format("YYYY/M/D");
  var ts = moment(today, "YYYY/M/D").valueOf();
  var epochDate = moment(ts);
  var warehouseId = "";
  var warehouseName = "";

  if (warehouseLocation === "italy") {
    warehouseId = "5f58b107baa4a733b2559431";
    warehouseName = "Sequentia Biotech Italia - Villa Ocsia";
  } else if (warehouseLocation === "spain") {
    warehouseId = "5ab8f74d2e1d935f2c60effc";
    warehouseName = "Sequentia Biotech Barcelona";
  }

  const stringedData = JSON.stringify({
    contactId: customerHoldedId,
    applyContactDefaults: false,
    date: epochDate,
    warehouseId: warehouseId,
    isCompany: isCompany,
    units: units,
    amount: amount,
    seqTechnology: seqTechnology,
    doctorFullName,
    doctorEmail,
    doctorMobile,
    tags: [
      "mick-patient",
      dashedAffiliation,
      isViesfiscalId ? "VIES" : null,
      seqTechnology,
      warehouseName,
    ],
    desc: `Customer( ${
      isCompany ? "Company" : "Person"
    }) requested ${units} KIT + Analysis package (MICK+ ${seqTechnology}) and proceeded with the payment. Check on PayPal account the total amount ${amount} €`,
    items: [{ units: units }], //? for a better control on billing process and shipped products, Claudia & Alba will add manually the kits in the sale order and transform it in a invoice

    // items: [{ units: units, sku: sku }], //? for a better control on billing process and shipped products, Claudia & Alba will add manually the kits in the sale order and transform it in a invoice
  });

  console.log(stringedData);

  return await fetch(`/mick/holded/documents/${docType}?key=${holdedKey}`, {
    method: "post",

    headers: {
      accept: "application/json",
      "content-type": "application/json",
      key: holdedKey,
    },
    redirect: "follow",
    body: stringedData,
  })
    .then((response) => response.json())
    .then((result) => {
      console.log(result);
      return result;
    });
};

function* addDocumentItemHolded(payload) {
  try {
    const response = yield call(addDocumentItemHoldedRequest, payload);
    console.log(response);
    if (response.status === "success") {
      yield put(addDocumentItemHoldedSuccess(response));
    } else {
      yield put(addDocumentItemHoldedError(response.info));
    }
  } catch (error) {
    yield put(addDocumentItemHoldedError(error));
  }
}

//* CLEAR KIT DATA // ---------------------------------------------------------------------------------------------

function clearDataHolded({ payload }) {
  const { history } = payload;
}

//!2. Our watcher saga
// our watcher saga spawn a new task on each action

export function* watchGetContactsListHolded() {
  yield takeEvery(HOLDED_GET_CONTACTS_LIST, getContactsListHolded);
}

export function* watchGetContactInfoHolded() {
  yield takeEvery(HOLDED_GET_CONTACT_INFO, getContactInfoHolded);
}

export function* watchAddContactInfoHolded() {
  yield takeEvery(HOLDED_ADD_CONTACT_INFO, addContactInfoHolded);
}

export function* watchUpdateContactInfoHolded() {
  yield takeEvery(HOLDED_UPDATE_CONTACT_INFO, updateContactInfoHolded);
}

export function* watchAddDocumentHolded() {
  yield takeEvery(HOLDED_ADD_DOCUMENT_ITEM, addDocumentItemHolded);
}

export function* watchClearDataHolded() {
  yield takeEvery(HOLDED_CLEAR_DATA, clearDataHolded);
}

//!3. Our root saga
// single entry point to start sagas at once

export default function* rootSaga() {
  yield all([
    fork(getContactsListHolded),
    fork(watchGetContactInfoHolded),
    fork(watchAddContactInfoHolded),
    fork(watchUpdateContactInfoHolded),
    fork(watchAddDocumentHolded),
    fork(watchClearDataHolded),
  ]);
}
